import { ChatEventType, ConnectionState } from "../enums";
import { ChatEvent } from "./ChatEvent";

export interface ConnectionStateChangedEventParams {
  readonly state: ConnectionState;
}

export class ConnectionStateChangedEvent
  implements ChatEvent<ChatEventType.ConnectionStateChanged> {
  readonly type = ChatEventType.ConnectionStateChanged;
  readonly state: ConnectionState;

  constructor( state : ConnectionState) {
    this.state = state;
  }
}
